// extracted by mini-css-extract-plugin
export default {"codeContainer":"styles_codeContainer__G-HWq"};